import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const TestimonialsSlider = () => {
  const sliders = Array.from(document.querySelectorAll('[data-testimonials-slider]'));
  if (!sliders.length) {
    return;
  }

  sliders.forEach((root) => {
    const viewport = root.querySelector('.o-testimonials-slider__viewport');
    const slides = Array.from(root.querySelectorAll('.o-testimonials-slider__slide'));
    const prevButton = root.querySelector('[data-testimonials-slider-prev]');
    const nextButton = root.querySelector('[data-testimonials-slider-next]');

    if (!viewport || slides.length <= 1) {
      return;
    }

    new Swiper(viewport, {
      autoplay: {
        delay: 5000,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 380,
      loop: true,
      watchOverflow: true,
      keyboard: {
        enabled: true,
      },
      navigation:
        prevButton && nextButton
          ? {
              prevEl: prevButton,
              nextEl: nextButton,
            }
          : false,
      a11y: {
        prevSlideMessage: 'Previous testimonial',
        nextSlideMessage: 'Next testimonial',
      },
      on: {
        init: (swiper) => {
          root.setAttribute('data-current-slide', String(swiper.realIndex + 1));
        },
        slideChange: (swiper) => {
          root.setAttribute('data-current-slide', String(swiper.realIndex + 1));
        },
      },
    });
  });
};

export default TestimonialsSlider;
